<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="facilitator" v-for="item of facilitatorList" :key="item.id">
        <p class="facilitatorName">{{ item.goodsName }}</p>
        <el-button style="width: 137px" type="primary" @click="choose(item.goodsName, item.merchantId)">选择</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { merchantList } from '../../../../api/module/merchants';

export default {
  props: {},
  data() {
    return {
      facilitatorList: [
        // {
        //   name: '美好北京',
        //   id: 0,
        // },
        // {
        //   name: '美好西安',
        //   id: 1,
        // },
      ],
    };
  },

  watch: {},
  created() {
    this.merchantList();
  },
  methods: {
    choose(facilitatorName, merchantId) {
      this.$router.push({
        path: '/merchants/subjectType',
        query: {
          facilitatorName,
          merchantId,
          type: 'add',
        },
      });
    },
    async merchantList() {
      const result = await merchantList({});
      this.facilitatorList = result;
      console.log('首页列表数据', result);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.box {
  display: flex;
  .facilitator {
    width: 322px;
    height: 172px;
    border: 1px solid #dbdbdb;
    border-radius: 8px;
    font-size: 18px;
    color: #333;
    margin-right: 16px;
    text-align: center;
    background-color: white;
    .facilitatorName {
      margin-top: 34px;
      margin-bottom: 42px;
    }
  }
}
</style>
